import { CustomLevelCardStyle } from '../../../../../components/Styles';
import { Box } from '@mui/material';
import ButtonAction from './../../../../../components/buttons/ButtonAction';
import CustomChip from './../../../../../components/CustomChip';

import {
    CheckOutlineIcon,
    CommentOutlineIcon,
    DeniedOutlineIcon,
    DownloadIcon
} from '../../../../../components/buttons/IconButtons';
import { statusBorderColor, statusColor, statusFontColor } from './../../../../../enums/statusColorEnum';
import { status, STATUS_MODEL } from '../../../../../enums/statusEnum';
import { colors } from '../../../../../enums/colors';
import CustomFileCard from './../../../../../components/CustomFileCard';
import { FIELD_TYPE, FIELD_TYPES_MODEL } from '../../../Visitor/Type/Model/Model';
import {
    DATE_TIME_FORMAT_NAME_MODEL,
    downloadActionFile,
    EMPTY_VALUES,
    getDateFormat
} from '../../../../../Apis/functions';
import TextCard from '../../SubComponents/TextCard';
import {URL} from '../../../../../Apis/Constants';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

const LevelDocumentCard = ({
    item,
    disabled,
    t,
    setShowApprove,
    setShowDenied,
    setShowIssueComment,
    setRow,
}) => {
    let matchStatus = item?.canApprove ||
        item?.statusId === STATUS_MODEL.DENIED ||
        item?.statusId === STATUS_MODEL.CHANGES_REQUESTED ||
        item?.statusId === STATUS_MODEL.APPROVED ;
    let styles = CustomLevelCardStyle(matchStatus ? item?.statusId : STATUS_MODEL.PENDING, disabled);

    const fieldTypes = FIELD_TYPES_MODEL();
    const titleChip = (legend, IconComponent) => (
        <div className='mt-2'>
            <CustomChip
                background={!disabled ? colors.secondary100 : colors.secondary50}
                fontColor={!disabled ? colors.secondary700 : colors.secondary200}
                borderColor={!disabled ? colors.secondary150 : colors.secondary100}
                legend={legend}
                icon={IconComponent ? <IconComponent /> : null}
                className={!disabled ? 'icon-color-secondary-700' : 'icon-color-secondary-200'}
            />
        </div>
    );

    const SectionTextFile = ({ doc }) => {
        const fieldTypeData = fieldTypes.find((ft) => ft.id === doc.levelType);
        const IconComponent = fieldTypeData?.icon;
        const legend = fieldTypeData?.name || doc.levelType;
        const isText = doc.levelType === FIELD_TYPE.TEXT.name;
        const isFile = doc.levelType === FIELD_TYPE.DOCUMENT.name;
        const filePath = doc?.fileUploadDto?.filePath || null;

        return (<>
            {isText && (
                <TextCard
                    showIcon={false}
                    title={titleChip(legend, IconComponent)}
                    disabled={disabled}
                    subtitle={
                        <p
                            className={`fs-14px ibl-font-w-400 text-ellipsis-1-row mt-3 ${disabled ? 'font-color-shades-300' : 'font-color-shades-600'
                                }`}
                        >
                            {t('uploaded')}:{' '}
                            {getDateFormat(
                                doc?.updatedAt,
                                true,
                                DATE_TIME_FORMAT_NAME_MODEL.shortMonth,
                            )}
                        </p>
                    }
                    showChip={false}
                    showText={true}
                    text={doc?.document || EMPTY_VALUES.DEFAULT}
                    footer={
                        doc?.reason && (
                            <Box className='mt-2 mx-0'>
                                <Box style={styles.boxComentary}>
                                    <p>{doc?.reason}</p>
                                </Box>
                            </Box>
                        )
                    }
                    copyOnClick={true}
                />
            )}

            {isFile && (
                <CustomFileCard
                    downloadAtEnd
                    showIcon={false}
                    downloadIcon={DownloadIcon}
                    disabledBtnDownload={disabled}
                    title={titleChip(legend, IconComponent)}
                    fileValue={filePath}
                    showBtnDownload={true}
                    onClick={()=>{
                        if(disabled) return;
                        downloadActionFile(URL + filePath);
                    }}
                    subtitle={
                        <>
                            <p
                                className={`fs-14px ibl-font-w-400 text-ellipsis-1-row mt-3 ${disabled ? 'font-color-shades-300' : 'font-color-shades-600'
                                    }`}
                            >
                                {t('uploaded')}:{' '}
                                {getDateFormat(
                                    doc?.updatedAt,
                                    true,
                                    DATE_TIME_FORMAT_NAME_MODEL.shortMonth,
                                )}
                            </p>
                        </>
                    }
                    footer={
                        doc?.reason && (
                            <Box className=' mt-2 mx-0'>
                                <Box style={styles.boxComentary}>
                                    <p>{doc?.reason}</p>
                                </Box>
                            </Box>
                        )
                    }
                    showChip={false}
                    buttonId={`btn_ldc_download_${doc.id}`}
                    classContent={'pb-3'}
                    showTooltip={true}
                />
            )}

        </>)
    }


    const getStatusText = () => {
        switch (item?.statusId) {
            case STATUS_MODEL.DENIED:
                return `${t('denied_by')} ${item?.approverFullName}`;
            case STATUS_MODEL.CHANGES_REQUESTED:
                return `${t('changes_request_by')} ${item?.approverFullName}`;
            case STATUS_MODEL.APPROVED:
                return `${t('accepted_by')} ${item?.approverFullName}`;
            default:
                return `${t('department_validation')}:`;
        }
    };

    return (
        <>
            <div className='d-flex justify-content-start mt-5'>
                <div className='d-flex flex-column align-items-center'>
                    <div style={styles.circle} className='mb-32px mr-32px' />
                    <div style={styles.line} className='mr-32px' />
                </div>
                <div style={styles.container}>
                    <div style={styles.levelCard}>
                        <div className='d-flex justify-content-between align-items-center'>
                            <p style={styles.level}>{item?.levelName}</p>
                        </div>

                        <div className='d-flex justify-content-between align-items-center'>
                            <div className='d-flex align-items-center gap-2'>
                                <span style={styles.span}>{getStatusText()}</span>
                                <CustomChip
                                    background={!disabled ? colors.secondary100 : colors.secondary50}
                                    fontColor={!disabled ? colors.secondary700 : colors.secondary200}
                                    borderColor={!disabled ? colors.secondary150 : colors.secondary100}
                                    legend={item?.departmentName || EMPTY_VALUES.DEFAULT}
                                />
                            </div>
                            <div className='d-flex-end gap-2'>
                                <CustomChip
                                    variant='large'
                                    background={!disabled ? statusColor[item?.statusId] : colors.shades200}
                                    fontColor={!disabled ? statusFontColor[item?.statusId] : colors.shades400}
                                    borderColor={!disabled ? statusBorderColor[item?.statusId] : colors.shades150}
                                    legend={item?.statusId ? t(status[item.statusId]) : EMPTY_VALUES.DEFAULT}
                                />
                                {item?.statusId !== STATUS_MODEL.DENIED &&
                                    item?.statusId !== STATUS_MODEL.CHANGES_REQUESTED &&
                                    item?.statusId !== STATUS_MODEL.APPROVED &&
                                    item?.canApprove &&
                                    !disabled && (
                                        <>
                                            <ButtonAction
                                                Icon={CheckOutlineIcon}
                                                id='btn_ldc_approved_modal'
                                                className='btn-icon-svg-chip-button btn-outlined-success-600 w-40px h-40px minw-40px p-0'
                                                iconProps='icon'
                                                iconClass='mr-0'
                                                onClick={() => {
                                                    setRow(item);
                                                    setShowApprove(true);
                                                }}
                                            />
                                            <ButtonAction
                                                Icon={DeniedOutlineIcon}
                                                id='btn_ldc_denied_modal'
                                                className='btn-icon-svg-chip-button btn-outlined-error-600 w-40px h-40px minw-40px p-0'
                                                iconProps='icon'
                                                iconClass='mr-0'
                                                onClick={() => {
                                                    setRow(item);
                                                    setShowDenied(true);
                                                }}
                                            />


                                            <ButtonAction
                                                Icon={CommentOutlineIcon}
                                                id='btn_ldc_comment_modal'
                                                className='btn-icon-svg-chip-button btn-outlined-warning-600 w-40px h-40px minw-40px p-0'
                                                iconProps='icon'
                                                iconClass='mr-0'
                                                onClick={() => {
                                                    setRow(item);
                                                    setShowIssueComment(true);
                                                }}
                                            />

                                        </>
                                    )}
                            </div>
                        </div>

                        {item?.statusId !== STATUS_MODEL.PENDING_REVIEW &&
                            <div className='d-flex justify-content-start align-items-center fs-12px ibl-font-w-300 font-color-shades-600'>
                                {getDateFormat(
                                    item?.decisionDate,
                                    true,
                                    DATE_TIME_FORMAT_NAME_MODEL.shortMonth,
                                )}
                            </div>
                        }

                    </div>
                    <div className='d-flex flex-column w-100 gap-3 p-16px'>
                        <SectionTextFile
                            doc={item}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default LevelDocumentCard;
